/**
 * Activation du comportement dynamique pour l'agenda UNantes (/servlet/agenda).
 */
(function initAgenda($) {
    'use strict';

    $.fn.visible = function(partial) {

        var $t            = $(this),
            $w            = $(window),
            viewTop       = $w.scrollTop(),
            viewBottom    = viewTop + $w.height(),
            _top          = $t.offset().top,
            _bottom       = _top + $t.height(),
            compareTop    = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };

    /**
     * Initialisation du composant calendar.
     * Source : https://longbill.github.io/jquery-date-range-picker/
     */
    function initCalendar() {
        // Surcharges FR du plugin JS
        $.dateRangePickerLanguages['fr']['week-1'] = 'lun';
        $.dateRangePickerLanguages['fr']['week-2'] = 'mar';
        $.dateRangePickerLanguages['fr']['week-3'] = 'mer';
        $.dateRangePickerLanguages['fr']['week-4'] = 'jeu';
        $.dateRangePickerLanguages['fr']['week-5'] = 'ven';
        $.dateRangePickerLanguages['fr']['week-6'] = 'sam';
        $.dateRangePickerLanguages['fr']['week-7'] = 'dim';
        $('.js-agenda__calendar').each(function () {
            var $t = $(this);
            var $from = $('.js-agendadatefrom', $t);
            var $to = $('.js-agendadateto', $t);
            var $container = $('.js-daterange__container', $t);
            $t.dateRangePicker({
                hoveringTooltip: false,
                inline: true,
                format: 'DD/MM/YYYY',
                container: $container,
                alwaysOpen: true,
                singleMonth: true,
                showShortcuts: false,
                showTopbar: false,
                selectForward: true,
                startOfWeek: 'monday',
                language: 'fr',
                customArrowPrevSymbol: '<span class="icon icon-chevron_left"></span>',
                customArrowNextSymbol: '<span class="icon icon-chevron_right"></span>',
                setValue: function (periode, startDate, endDate) {
                    $from.val(startDate);
                    $to.val(endDate);
                },
                separator: ' to ',
                getValue: function () {
                    if ($from.val() && $to.val()) {
                        return $from.val() + ' to ' + $to.val();
                    }
                    return '';
                }
            }).bind('datepicker-first-date-selected', function (event, obj) {
                // Lors du clic sur une date du filtre et la validation, on doit rechercher avec dateDebut = dateFin = date choisi par l'utilisateur sur le clic
                var firstDateFormatted = moment(obj.date1).format('DD/MM/YYYY');
                $from.val(firstDateFormatted);
                $to.val(firstDateFormatted);
            });
        });
    }

    /**
     * Initialisation de la fonctionnalité d'infinite scroll (plutôt qu'une pagination classique).
     */
    function initInfiniteScroll() {
        var infinite = new Waypoint.Infinite({
            element: $('.infinite-container')[0]
        });
    }

    /* function initSticky() {
        var sticky = new Waypoint.Sticky({
            element: $('.form__agregation-search')[0],
            stuckClass: 'form__calendar--stuck',
            handler: function() {
                $('.agenda').removeClass('come-in');
            }
        });
        // Positionner un waypoint en haut du footer pour désactiver les filtres sticky sur cette zone.
        var footerWaypoint = new Waypoint({
            element: $('footer')[0],
            handler: function(direction) {
                var agendaForm = $('.agenda form');
                var stickyWrapper = $('.sticky-wrapper');
                if (direction ==='down' && agendaForm.hasClass('form__calendar--stuck')) {
                    agendaForm.removeClass('form__calendar--stuck');
                    stickyWrapper.addClass('sticky-wrapper--bottom');
                } else if (direction ==='up' && stickyWrapper.hasClass('sticky-wrapper--bottom')){
                    agendaForm.addClass('form__calendar--stuck');
                    stickyWrapper.removeClass('sticky-wrapper--bottom');
                }
            },
            offset: '100%'
        });
    } */
    /**
     * Initialisation du carrousel pour l'agenda UNantes.
     */
    function initAgendaCarousel() {
        var nextIcon = '<img style="float:right; width:100px;height:100px;" src="../../../../jsp/images/arrow-next-caroussel.svg" alt="Prochaine actualité"/>';
        $('.agenda__caroussel .owl-carousel').each(function () {
            var $t = $(this);
            if ($t.attr('data-context') !== 'agenda' || $t.children().length <= 1) {
                return;
            }
            $t.owlCarousel({
                loop: true,
                nav: true,
                dots: true,
                autoplay: true,
                mouseDrag: true,
                touchDrag: true,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                navText: [
                    '', nextIcon
                ],
                items: 1,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true
                    },
                    600: {
                        items: 1,
                        nav: false
                    }
                }
            });
        });
    }

    function initFiltresMoisHorizontal() {
        $('.nav__month').each(function initFiltreMois() {
            var $parent = $(this);
            var $list = $('.nav__month-list', $parent);
            var $leftArrow = $('.nav__month-previous', $parent);
            var $rightArrow = $('.nav__month-next', $parent);
            var scrollHandle = 0,
                scrollStep = 5,
                maxOffset = $list[0].scrollWidth - $list[0].clientWidth;
            $('.nav__month-previous', $parent).on('mousedown touchstart', function onMonthPreviousMouseOver() {
                $(this).addClass('active');
                startScrolling(scrollStep * -1);
            });
            $('.nav__month-next', $parent).on('mousedown touchstart', function onMonthNextMouseOver() {
                $(this).addClass('active');
                startScrolling(scrollStep);
            });
            //Kill the scrolling
            $('.nav__month-previous', $parent).on('mouseup mouseleave touchend', function onMonthPreviousMouseLeave() {
                stopScrolling();
                $(this).removeClass('active');
            });
            $('.nav__month-next', $parent).on('mouseup mouseleave touchend', function onMonthNextMouseLeave() {
                stopScrolling();
                $(this).removeClass('active');
            });

            //Actual handling of the scrolling
            function startScrolling(step) {
                if (scrollHandle === 0) {
                    scrollHandle = setInterval(function () {
                        var newOffset = $list.scrollLeft() + step;
                        $list.scrollLeft(newOffset);
                        /* Si on arrive au bout, tout à droite*/
                        /* if(maxOffset < newOffset){
                            maxOffset = newOffset;
                            $leftArrow.removeClass('nav__month-previous--after');
                        } else if (newOffset < 0) {
                            maxOffset = 0;
                            $rightArrow.removeClass('nav__month-next--after');
                        } */
                        /* if (maxOffset < newOffset) {
                            maxOffset = newOffset;
                        } */
                        if (newOffset >= maxOffset) {
                            $rightArrow.removeClass('nav__month-next--after');
                        } else {
                            $rightArrow.addClass('nav__month-next--after');
                        }
                        if (newOffset <= 0) {
                            $leftArrow.removeClass('nav__month-previous--before');
                        } else {
                            $leftArrow.addClass('nav__month-previous--before');
                        }
                    }, 10);
                }
            }

            function stopScrolling() {
                clearInterval(scrollHandle);
                scrollHandle = 0;
            }

            // Désactiver l'overflow de manière programmatique (donc applicable uniquement si le JS est activé)
            $list.css('overflow-x', 'hidden');

            startScrolling(0)
        });
    }

    function initCategories() {
        $('.agenda__button-categories--more, .agenda__button-categories--less').on('click', function () {
            $('.agenda__button-categories--more, .agenda__button-categories--less').toggle();
            $('.agenda__categories').children('.item-list__hidden').toggle();
            $('.agenda__categories').toggleClass('agenda__categories--withoutdegraded');
        });
    }

    function initFiltersmobile() {
        $('.seemore__filters-mobile').on('click', function() {
            $('.agenda__calendar .form__agregation-search').toggleClass('form__agregation-search--open');
        });
    }

    /**
     * Initialise l'effet slide-in-boxes proposé par le designer.
     * Voir https://css-tricks.com/slide-in-as-you-scroll-down-boxes/
     */
    function initSlideBoxesEffect() {
        // Positionnement uniquement sur chaque bloc de type 'infinite-item' portée par la liste agenda
        // Pas d'impact voulu sur la liste de fiches.
        var selector = '.infinite-item';
        // La classe already-visible permet d'éviter l'effet clignotement sur une nouvelle page avec les items déjà présents.
        $(selector).each(function(i, el) {
            var $el = $(el);
            if ($el.visible(true)) {
                $el.addClass('already-visible');
            }
        });

        /**
         * Lors du scroll, on rajoute la classe avec transition positionnée.
         */
        $(window).scroll(function(event) {
            $(selector).each(function(i, el) {
                var $el = $(el);
                if ($el.visible(true)) {
                    $el.addClass('come-in');
                }
            });

        });
    }

    function initDayCheckedColor() {
        if($('.day').hasClass('hovering')) {
            $('.first-date-selected').toggleClass('first-date-selected--checked');
        }
    }

    $(window).on('ready', function onAgendaDomReady() {
        // initSticky();
        initAgendaCarousel();
        initCalendar();
        initInfiniteScroll();
        initFiltresMoisHorizontal();
        initCategories();
        initFiltersmobile();
        initSlideBoxesEffect();
        initDayCheckedColor();
    });
})(jQuery);
